var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m10.274.1 3.006 6.406 7.045.867-5.187 4.827 1.348 6.943-6.212-3.423-6.21 3.423L5.412 12.2.225 7.373l7.045-.867z"
})));
export default SvgStar;